import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    listPoliklinik: [],
    masterData: [],
    formPoli: {
        f_id_klinik_poliklinik: "",
        f_id_klinik: "",
        f_id_poliklinik: "",
        f_status_poliklinik: true,
    }
    
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_POLI_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_POLI_DATA_GET_ALL_SUCCESS: {
            return{
                ...state,
                listPoli: action.value
            }
        }
        case types.MODULE_POLI_DATA_GET_DETAIL_SUCCESS: {
            return{
                ...state,
                formPoli: action.value
            }
        }
        case types.MODULE_POLI_MASTER_DATA_SUCCESS: {
            return{
                ...state,
                masterData: {
                    ...state.masterData,
                    [action.property] : action.value
                }
            }
        }
        case types.MODULE_POLI_INIT_FORM_POLI: {
            return{
                ...state,
                formPoli: {
                    ...initState.formPoli
                }

            }
        }
        case types.MODULE_POLI_HANDLE_STATE_FORM: {
            if(action.property == 'f_id_poliklinik'){
                return {
                    ...state,
                    formPoli: {
                        ...state.formPoli,
                        f_id_poliklinik: parseInt(action.value),
                        // f_deskripsi_poliklinik: initState.masterData.listPoliklinik.filter(function(obj){return obj.f_id_poliklinik == action.value})
                    }
                }
            }else{
                return {
                    ...state,
                    formPoli: {
                        ...state.formPoli,
                        [action.property]: action.value,
                    }
                }
            }
        }
        default:
            return {
                ...state
            }
    }
}  